import React from "react";
import { ChevronDown, Download, RefreshCw } from "lucide-react";
import "./vulnerability.css";

const VulnerabilityChartSelector = ({
  currentChart,
  onChartChange,
  onDownload,
  onRefresh,
}) => {
  const charts = [
    { id: "line", label: "Line Chart" },
    { id: "bar", label: "Bar Chart" },
    // { id: "stacked-area", label: "Area Chart" },
    // { id: "pie", label: "Pie Chart" },
    // { id: "donut", label: "Donut Chart" },
    // { id: "radar", label: "Radar Chart" },
    // { id: "heatmap", label: "Heatmap" },
  ];

  const [isOpen, setIsOpen] = React.useState(false);
  const [downloadOpen, setDownloadOpen] = React.useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const toggleDownloadDropdown = () => setDownloadOpen(!downloadOpen);

  const handleChartSelect = (chartId) => {
    onChartChange(chartId);
    setIsOpen(false);
  };

  const handleDownload = (format) => {
    onDownload(format);
    setDownloadOpen(false);
  };

  const currentChartLabel =
    charts.find((chart) => chart.id === currentChart)?.label || "Select Chart";

  return (
    <div className="d-flex align-items-center">
      {/* Chart Type Dropdown */}
      <div className="dropdown">
        <button
          type="button"
          className="btn dropdown-toggle w-48 block"
          onClick={toggleDropdown}
          aria-expanded={isOpen}
        >
          {currentChartLabel}
          <ChevronDown className="ms-2" size={20} />
        </button>

        <div className={`dropdown-menu ${isOpen ? "show" : ""}`}>
          {charts.map((chart) => (
            <button
              key={chart.id}
              onClick={() => handleChartSelect(chart.id)}
              className={`dropdown-item ${
                currentChart === chart.id ? "active" : ""
              }`}
            >
              {chart.label}
            </button>
          ))}
        </div>
      </div>

      {/* Download Options Dropdown */}
      <div className="d-flex gap-3 dropdown chart-download">
        {/* Refresh Button */}
        <button
          type="button"
          className="btn"
          title="Refresh Data"
          onClick={onRefresh}
        >
          <RefreshCw size={15} />
        </button>

        <button
          type="button"
          className="btn dropdown-toggle d-flex mr-2"
          onClick={toggleDownloadDropdown}
          aria-expanded={downloadOpen}
        >
          <Download size={15} />
        </button>

        <div className={`dropdown-menu ${downloadOpen ? "show" : ""}`}>
          <button
            onClick={() => handleDownload("png")}
            className="dropdown-item"
          >
            Download as Image
          </button>
          <button
            onClick={() => handleDownload("pdf")}
            className="dropdown-item"
          >
            Download as PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default VulnerabilityChartSelector;
